import vid1 from "./Thumbnail.jpg"
import vid2 from "./Thumbnail2.jpg"
import vid3 from "./Thumbnail3.jpg"
import vid4 from "./Thumbnail4.jpg"
import vid5 from "./Thumbnail5.jpg"

export default [
    {
        id: 1,
        url:"https://www.youtube.com/watch?v=8pST3R7HefM&t=7s",
        thumbnail: vid1,
        title: "Best text editor for coding | VS code setup | Coding for beginners",
        desc: "In this video, we explain the importance of selecting a good text editor for a coding beginner to help them kickstart their coding journey. Also the whole setup of Visual Studio code is explained in this video."
    },
    {
        id: 2,
        url:"https://www.youtube.com/watch?v=Afgr90EbyRs&t=7s",
        thumbnail:vid2,
        title: "What is a compiler | Compiler setup for VS Code | C++ tutorials",
        desc: "We are going to explain what is compiler and install compiler for C and C++. We will look into the installation procedure as well as setup the whole thing in vs code and write our first C++ program of 'Hello world'."
    },
    {
        id: 3,
        url:"https://www.youtube.com/watch?v=Afgr90EbyRs&t=7s",
        thumbnail:vid3,
        title: "C++ header files and main function explanation | C++ tutorials",
        desc: "In this video, we look into the basic structure of how a C++ program looks like. Also we are going to explain the header files and the main function. We will create a user snippet so that we don't have to write this structure/boilerplate all the time."
    },
    {
        id: 4,
        url:"https://www.youtube.com/watch?v=zuGBPH3vaQU&t=39s",
        thumbnail:vid4,
        title: "Variables and Comments in C++ | C++ tutorials",
        desc: "In this video, we are going to look into the comments and variables in C++. We will also learn all the different types of variables that can be used and where to use them."
    },
    {
        id: 5,
        url:"https://www.youtube.com/watch?v=f8dN8RVydHo",
        thumbnail:vid5,
        title: "Data types and it's categories | C++ for beginners.",
        desc: "In this video, we are going to look into the different types of data types in C++ and learn the meaning of data type, look into it's categories and learn how to declare a variable of different data type."
    },
    {
        id: 6,
        url:"https://www.youtube.com/watch?v=f8dN8RVydHo",
        thumbnail:vid5,
        title: "Introduction to Web Development | Coding Ground",
        desc: "In this video, we introduce web development to all of you. We are covering of how a website works. This video is the foundation for all the upcoming web development videos."
    },

]